import { useBaseMutation } from "../../../../hooks/useBaseMutation";


export const usePutStoreInfo = () => {
    
    return useBaseMutation(
        'put',
        'https://api.menufy.link/restaurantBackend/stores/info', // Endpoint
        // 'storeInfo',
        // Data transformation function
    );
};
